import { getApiUrl } from "src/common/api/getUrl";
import { dataParser } from "src/common/dataParser";
import { rest } from "src/common/rest";

import { AccessObjectType } from "./AccessObjectType";
import { ZObjectAccess, zObjectAccess } from "./ZObjectAccess";

const urlObjectAccess = (type: AccessObjectType, objId: string) =>
  getApiUrl(`/core/views/${type}/${objId}`);

export const loadObjectAccess = async (
  type: AccessObjectType,
  objId: string,
): Promise<ZObjectAccess> => {
  const resp = await rest.get(urlObjectAccess(type, objId));
  return dataParser(() => zObjectAccess.parse(resp.data), `loadObjectAccess`);
};

export const saveObjectAccess = async (
  type: AccessObjectType,
  objId: string,
  data: ZObjectAccess,
): Promise<ZObjectAccess> => {
  const resp = await rest.put(urlObjectAccess(type, objId), data);
  return dataParser(() => zObjectAccess.parse(resp.data), "saveObjectAccess");
};
